import { Injectable } from '@angular/core';
import { PrestationClientService } from '../../../../core/services/prestation-client.service';
import { map, Observable } from 'rxjs';
import { TypePrestation } from './type-prestation.model';
import { InlineResponse } from '../../../../core/models/inline-response.model';
import { Prestation } from './prestation.model';

import { ContratAggregate, PrestationContratsAssocies, PrestationRequest } from './contrats-associes/prestation--contrats-associes.model';
import { GenericResponse } from '../../../../core/models/generic-response.model';

@Injectable({
  providedIn: 'root',
})
export class ReferentialsPrestationsService {
  constructor(private prestationClientService: PrestationClientService) {}

  // Type Prestation
  getTypePrestation(): Observable<TypePrestation[]> {
    return this.prestationClientService.getAllTypePrestation().pipe(
      map((type) => type.rows),
      map((rows) => rows.map((row) => new TypePrestation(row.afficherSurLaConfirmation, row.codeHecate, row.designation, row.envoiTennaxia, row.id, row.suffisantPourDemande, row.transport, row.unite))),
    );
  }

  addTypePrestation(afficherSurLaConfirmation: boolean, codeHecate: number, designation: string, envoiTennaxia: boolean, suffisantPourDemande: boolean, transport: boolean, uniteId?: number): Observable<InlineResponse> {
    return this.prestationClientService.addTypePrestation(afficherSurLaConfirmation, codeHecate, designation, envoiTennaxia, suffisantPourDemande, transport, uniteId);
  }

  updateTypePrestation(typePrestation: TypePrestation): Observable<InlineResponse> {
    return this.prestationClientService.updateTypePrestation(typePrestation);
  }

  // Prestation
  getPrestation(): Observable<Prestation[]> {
    return this.prestationClientService.getAllPrestation().pipe(
      map((prestation) => prestation.rows),
      map((rows) => rows.map((row) => new Prestation(row.categorieAchatMosaic, row.codeDR, row.codeHecate, row.codeTennaxia, row.designation, row.id, row.libelleCaracteristiques, row.lienDechet, row.typeCodeHecate, row.typeDesignation, row.typeId, row.variante))),
    );
  }

  addPrestation(categorieAchatMosaic: string, codeDR: string, codeHecate: string, codeTennaxia: string, designation: string, libelleCaracteristiques: string, lienDechet: string, typeId: number): Observable<InlineResponse> {
    return this.prestationClientService.addPrestation(categorieAchatMosaic, codeDR, codeHecate, codeTennaxia, designation, libelleCaracteristiques, lienDechet, typeId);
  }

  updatePrestation(prestation: Prestation): Observable<InlineResponse> {
    return this.prestationClientService.updatePrestation(prestation);
  }

  getContratsAssocies(prestationId: number): Observable<PrestationContratsAssocies> {
    return this.prestationClientService.getContratAssocies(prestationId).pipe(
      map((prestationContratsAssocies) => prestationContratsAssocies),
      map(
        (prestationContratsAssocies) =>
          new PrestationContratsAssocies(
            new PrestationRequest(prestationContratsAssocies.prestationRequest.prestationId, prestationContratsAssocies.prestationRequest.contratIds),
            prestationContratsAssocies.contrats.map((row) => new ContratAggregate(row.id, row.libelle, row.entiteGestion, row.codeSocieteJuridique, row.commentaire)),
          ),
      ),
    );
  }

  saveContratAssocies(request: string): Observable<GenericResponse> {
    return this.prestationClientService.saveContratAssocies(request);
  }
}
